import React, { useState, useEffect } from 'react';
import LoadingIndicator from './../LoadingIndicator';
import { API_KEY, BASE_URL } from "../config";

function HedgeOffsetLevelDetails({ signalRequestId, refreshTrigger }) {
  const [level, setLevel] = useState(null); // Assuming only one object in the list
  const [loading, setLoading] = useState(true);

  const [saving, setSaving] = useState(false);

  const [error, setError] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  const unifiedButtonStyle = {
    padding: '6px 12px',
    fontSize: '13px',
    margin: '5px 8px 5px 0',
    borderRadius: '4px',
    border: 'none',
    backgroundColor: 'rgba(57, 65, 65, 0.85)', // equivalent of #394141da
    color: '#fff',
    fontWeight: 500,
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  };
  

  useEffect(() => {
    if (saving || isEditing) {
      return;
    }
    fetch(`${BASE_URL}/api/bot/ui/get/getHedgeOffsetLevels?signalRequestId=${signalRequestId}`,
                    {
                      headers: {
                        "X-SIGNALFLY-KEY": API_KEY
                      }
                    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        setLevel({ ...data[0], isEditable: false }); // Assuming data[0] is your object
        setLoading(false); 
      })
      .catch(error => {
        setError(error.message);
        setLoading(false);
      });
  }, [signalRequestId, refreshTrigger,isEditing,saving]);

  const handleChange = (e, key) => {
    setLevel({ ...level, [key]: e.target.value });
  };

  const editableFields = ['movingOffsetPrice', 'overrideOffsetPrice']; // Specify the editable fields


  const handleCancel = () => {
    setIsEditing(false);
    // Optionally, refetch the data to reset any unsaved changes
  };

  const handleSave = () => {
    setSaving(true);
    // Make API call to save the updated level
    fetch(`${BASE_URL}/api/bot/ui/get/saveHedgeOffsetLevels`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        "X-SIGNALFLY-KEY": API_KEY
      },
      body: JSON.stringify(level),
    })
    .then(response => {
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return response.json();
    })
    .then(updatedLevel => {
      setLevel({ ...updatedLevel, isEditable: false });
      setIsEditing(false);
      setSaving(false);
    })
    .catch(error => {
      setError(error.message);
      setLoading(false);
      setIsEditing(false);
      setSaving(false);
    });
  };

  const handleEdit = () => {
    setIsEditing(true);
    setLevel({ ...level, isEditable: true });
  };

  
  if (error) return <div>Error: {error}</div>;
  if (!level) return <div>No data found</div>;

  const excludedFields = ['offsetLevelId','signalRequestId','createdBy', 'createdDate', 'modifiedBy', 'modifiedDate', 'marginCoin','side'];

  return (
    <>
     {loading && <LoadingIndicator text="Loading" />}
     {saving && <LoadingIndicator text="Saving" />}

    <div className="mainContent">
      <br />
      <div>
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              {Object.keys(level)
                .filter(key => !excludedFields.includes(key))
                .map((key) => (
                  <th key={`header-${key}`} scope="col">{key}</th>
                ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              {Object.entries(level)
                .filter(([key, _]) => !excludedFields.includes(key))
                .map(([key, value]) => (
                  <td key={`value-${key}`}>
                  {level.isEditable && editableFields.includes(key) ? (
                    <input type="text" value={value ?? ''} onChange={(e) => handleChange(e, key)} />
                  ) : (
                    value != null ? value.toString() : ''
                  )}
                </td>
                ))}
            </tr>
          </tbody>
        </table>
      </div>      

    </div>
    <div className="button-container"> 
    <br/>
        {isEditing ? (
          <>
            <button  style={unifiedButtonStyle} onClick={handleSave}>Save</button> <span />
            <button  style={unifiedButtonStyle} onClick={handleCancel}>Cancel</button>
          </>
        ) : (
          <button style={unifiedButtonStyle} onClick={handleEdit}>Modify</button>
        )}
      </div></>
  );
}

export default HedgeOffsetLevelDetails;
